import { EventEmitter } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseComponent } from '../../../../shared/base.component';
import { SessionStorageService } from "ngx-webstorage";
import { Router } from "@angular/router";
import { User } from '../../../../core/user/user.model';
import { ConfirmAttributes } from '../confirm-attributes';
import { ResponseDTO } from '../response-dto';
import { UserService } from '../../../../core/user/user.service';
import { JhiLanguageService } from '../../../../ng-jhipster/language';
import { JhiEventManager } from '../../../../ng-jhipster/service';
import { AccountService } from '../../../../core/auth/account.service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-webstorage";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "@angular/router";
import * as i4 from "../../../../core/user/user.service";
import * as i5 from "../../../../ng-jhipster/language";
import * as i6 from "../../../../ng-jhipster/service";
import * as i7 from "../../../../core/auth/account.service";
import * as i8 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i9 from "@angular/common";
import * as i10 from "@fortawesome/angular-fontawesome";
import * as i11 from "@ctrl/ngx-emoji-mart/ngx-emoji";
import * as i12 from "../../../../shared/language/find-flag-code-from-key.pipe";
import * as i13 from "../../../../shared/language/find-language-from-key.pipe";
function SessionScheduledPopupComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "span", 39);
    i0.ɵɵelementStart(2, "span", 40);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.selectedUser.login);
} }
function SessionScheduledPopupComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "span", 41);
    i0.ɵɵelementStart(2, "span", 40);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.confirmAttributes.coach.login);
} }
function SessionScheduledPopupComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "a", 43);
    i0.ɵɵlistener("click", function SessionScheduledPopupComponent_div_27_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 44);
    i0.ɵɵlistener("click", function SessionScheduledPopupComponent_div_27_Template_a_click_3_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.donate(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 45);
    i0.ɵɵelement(5, "img", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 47);
    i0.ɵɵelement(7, "hr");
    i0.ɵɵelement(8, "p", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function SessionScheduledPopupComponent_div_52_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵelementStart(1, "button", 50);
    i0.ɵɵlistener("click", function SessionScheduledPopupComponent_div_52_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { threshold: a0 }; };
function SessionScheduledPopupComponent_div_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelement(1, "p", 52);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c0, ctx_r5.threshold));
} }
const _c1 = function (a0, a1) { return { date: a0, time: a1 }; };
const _c2 = function (a0) { return { value: a0 }; };
export class SessionScheduledPopupComponent extends BaseComponent {
    constructor(sessionStorage, modalService, router, userService, languageService, eventManager, accountService) {
        super(sessionStorage, modalService);
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.router = router;
        this.userService = userService;
        this.languageService = languageService;
        this.eventManager = eventManager;
        this.accountService = accountService;
        this.onScheduleSession = new EventEmitter();
    }
    ngOnInit() {
        this.langKey = this.languageService.getCurrentLanguage();
        this.userService.getRegionObjectByName(this.selectedUser.region).subscribe(region => {
            this.threshold = Math.round(region.cancellationThreshold / 6) / 10;
        });
        console.log(this.session);
    }
    toggleDropdown(event) { }
    collapseDropdown(event) { event.close(); }
    close() {
        this.onScheduleSession.emit(this.session);
        this.closeAll();
        this.smoothScrollUp();
        if (!this.router.url.includes("/index-")) {
            if (this.accountService.hasAnyAuthority(['ROLE_COACH'])) {
                this.router.navigate(["/index-coach"]).then();
            }
            else if (this.accountService.hasAnyAuthority(['ROLE_CUSTOMER_CARE'])) {
                this.eventManager.broadcast('scheduleForCustomerCare');
                this.eventManager.broadcast({ name: 'selectedConversationChanged', content: this.selectedUser.id });
            }
            else if (this.accountService.hasAnyAuthority(['ROLE_USER'])) {
                this.router.navigate(["/index-user"]).then();
            }
        }
    }
    closeAll() {
        this.modalService.dismissAll();
    }
    smoothScrollUp() {
        // const scrollToTop =
        window.setTimeout(() => {
            // const pos: number = window.pageYOffset;
            window.scrollTo(0, 0); // how far to scroll on each step
        }, 100);
    }
    donate() {
        this.close();
        window.open("https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=GUXC8KPHJ7XFG", "_blank", "toolbar=yes, scrollbars=yes, resizable=yes, top=400, left=300, width=500, height=500");
    }
}
SessionScheduledPopupComponent.ɵfac = function SessionScheduledPopupComponent_Factory(t) { return new (t || SessionScheduledPopupComponent)(i0.ɵɵdirectiveInject(i1.SessionStorageService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i4.UserService), i0.ɵɵdirectiveInject(i5.JhiLanguageService), i0.ɵɵdirectiveInject(i6.JhiEventManager), i0.ɵɵdirectiveInject(i7.AccountService)); };
SessionScheduledPopupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SessionScheduledPopupComponent, selectors: [["session-scheduled-popup"]], inputs: { selectedUser: "selectedUser", confirmAttributes: "confirmAttributes", coachLanguages: "coachLanguages", sessionType: "sessionType", responseDTO: "responseDTO", session: "session", isCoach: "isCoach", isCoronaUser: "isCoronaUser", googleReminder: "googleReminder", outlookReminder: "outlookReminder", yahooReminder: "yahooReminder", momentDate: "momentDate", langKey: "langKey", sessionId: "sessionId" }, outputs: { onScheduleSession: "onScheduleSession" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 54, vars: 24, consts: [[1, "modal-body", "offset-1", "col-10", "olha-theme"], [1, "w-100", "py-2", "text-center"], ["src", "../../../../../../../../../../../../content/images/inuka/dancing-blob.png", "alt", "dancing blob"], ["jhiTranslate", "sessionSchedule.paragraph.bookingCompleted", 2, "color", "black", "text-align", "center"], ["jhiTranslate", "sessionSchedule.paragraph.confirmationEmail"], [1, "justify-content-start", "align-items-center", "col"], ["class", "d-flex justify-content-start align-items-center mb-3", 4, "ngIf"], [1, "d-flex", "justify-content-start", "align-items-center", "mb-3"], ["jhiTranslate", "sessionSchedule.paragraph.date", 2, "font-weight", "bold", "flex", "0 0 30%"], ["icon", "calendar", 1, "mr-2"], ["jhiTranslate", "sessionSchedule.paragraph.dateValue", 2, "flex", "1", 3, "translateValues"], ["jhiTranslate", "sessionSchedule.paragraph.sessionType", 2, "font-weight", "bold", "flex", "0 0 30%"], [2, "height", "14px", "width", "14px", "margin-right", "4px"], [0, "xlink", "href", ""], [2, "flex", "1", 3, "jhiTranslate"], ["jhiTranslate", "sessionSchedule.paragraph.language", 2, "font-weight", "bold", "flex", "0 0 30%"], [3, "emoji"], [1, "ml-1", 2, "flex", "1"], ["jhiTranslate", "sessionSchedule.paragraph.duration", 2, "font-weight", "bold", "flex", "0 0 30%"], ["jhiTranslate", "sessionSchedule.paragraph.durationValue", 2, "flex", "1", 3, "translateValues"], ["class", "w-100", 4, "ngIf"], ["role", "button", 1, "d-md-none", 2, "padding", "5px 5px 5px 10px"], ["target", "_blank", 3, "href"], ["src", "../../../../../../../../../../../../content/images/inuka/google_64px.png", "alt", "google", 2, "height", "15px", "width", "auto"], ["jhiTranslate", "sessionSchedule.paragraph.googleCalendar", 2, "padding-left", "5px", "font-size", "14px", "color", "black", "text-decoration", "none"], ["ngbDropdown", "", 1, "d-none", "d-md-block", "d-lg-block", "d-xl-block", "emoji-dropdown", 3, "openChange"], ["calendarReminderDropdown", "ngbDropdown"], ["ngbDropdownToggle", "", 1, "navbar-toggler", 2, "padding-top", "0.5rem!important"], ["src", "../../../../../../../../../../../../content/images/inuka/calendar.png", "alt", "calendar", 2, "height", "20px", "width", "auto"], ["jhiTranslate", "sessionSchedule.paragraph.calendar", 2, "padding-left", "5px", "font-size", "14px"], ["ngbDropdownMenu", "", 3, "click"], [3, "click"], ["role", "button", 2, "padding", "5px 5px 5px 10px"], ["src", "../../../../../../../../../../../../content/images/inuka/outlook-app-icon@2x.png", "alt", "outlook", 2, "height", "15px", "width", "auto"], ["jhiTranslate", "sessionSchedule.paragraph.outlookCalendar", 2, "padding-left", "5px", "font-size", "14px", "color", "black", "text-decoration", "none"], ["src", "../../../../../../../../../../../../content/images/inuka/yahoo-app-icon.jpg", "alt", "yahoo", 2, "height", "15px", "width", "auto"], ["jhiTranslate", "sessionSchedule.paragraph.yahooCalendar", 2, "padding-left", "5px", "font-size", "14px", "color", "black", "text-decoration", "none"], ["class", "mt-4 text-center", 4, "ngIf"], ["class", "mt-3 text-center", 4, "ngIf"], ["jhiTranslate", "sessionSchedule.paragraph.user", 2, "font-weight", "bold", "flex", "0 0 30%"], [1, "mr-2", 2, "flex", "1"], ["jhiTranslate", "sessionSchedule.paragraph.coach", 2, "font-weight", "bold", "flex", "0 0 30%"], [1, "w-100"], ["jhiTranslate", "sessionSchedule.button.getItForFree", 1, "btn-2", "btn-2-success", "font-weight-bold", "voucher-apply-button", "border-rounded", 3, "click"], ["type", "button", "jhiTranslate", "sessionSchedule.button.payWhatICan", 1, "btn", "btn-success", "font-weight-bold", 2, "float", "right!important", "border-radius", "40px", 3, "click"], [1, "mt-1"], ["src", "../../../../../../../../../../../../content/images/credit-cards-accepted-logo.jpg", "alt", "payment-methods", "width", "130", 1, "px-2", "float-right"], [1, "mt-5"], ["jhiTranslate", "sessionSchedule.paragraph.anyPayment", 2, "text-align", "left", "font-size", "12px!important", "font-weight", "bold", "font-style", "italic"], [1, "mt-4", "text-center"], ["jhiTranslate", "sessionSchedule.button.complete", "id", "session-schedule-finish-btn", 1, "btn-2", "btn-2-green", "px-4", 3, "click"], [1, "mt-3", "text-center"], ["jhiTranslate", "sessionSchedule.paragraph.upTo24Hours", 2, "font-size", "12px", "font-weight", "bold", "color", "darkgrey", 3, "translateValues"]], template: function SessionScheduledPopupComponent_Template(rf, ctx) { if (rf & 1) {
        const _r11 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "img", 2);
        i0.ɵɵelement(3, "h3", 3);
        i0.ɵɵelement(4, "p", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtemplate(6, SessionScheduledPopupComponent_div_6_Template, 4, 1, "div", 6);
        i0.ɵɵtemplate(7, SessionScheduledPopupComponent_div_7_Template, 4, 1, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelement(9, "span", 8);
        i0.ɵɵelement(10, "fa-icon", 9);
        i0.ɵɵelement(11, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 7);
        i0.ɵɵelement(13, "span", 11);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(14, "svg", 12);
        i0.ɵɵelement(15, "use", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(16, "span", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 7);
        i0.ɵɵelement(18, "span", 15);
        i0.ɵɵelement(19, "ngx-emoji", 16);
        i0.ɵɵpipe(20, "findFlagCodeFromKey");
        i0.ɵɵelementStart(21, "span", 17);
        i0.ɵɵtext(22);
        i0.ɵɵpipe(23, "findLanguageFromKey");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 7);
        i0.ɵɵelement(25, "span", 18);
        i0.ɵɵelement(26, "span", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(27, SessionScheduledPopupComponent_div_27_Template, 9, 0, "div", 20);
        i0.ɵɵelementStart(28, "div", 1);
        i0.ɵɵelementStart(29, "div", 21);
        i0.ɵɵelementStart(30, "a", 22);
        i0.ɵɵelement(31, "img", 23);
        i0.ɵɵelement(32, "span", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 25, 26);
        i0.ɵɵlistener("openChange", function SessionScheduledPopupComponent_Template_div_openChange_33_listener($event) { return ctx.toggleDropdown($event); });
        i0.ɵɵelementStart(35, "button", 27);
        i0.ɵɵelement(36, "img", 28);
        i0.ɵɵelement(37, "span", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 30);
        i0.ɵɵlistener("click", function SessionScheduledPopupComponent_Template_div_click_38_listener() { i0.ɵɵrestoreView(_r11); const _r3 = i0.ɵɵreference(34); return ctx.collapseDropdown(_r3); });
        i0.ɵɵelementStart(39, "div", 31);
        i0.ɵɵlistener("click", function SessionScheduledPopupComponent_Template_div_click_39_listener() { i0.ɵɵrestoreView(_r11); const _r3 = i0.ɵɵreference(34); return ctx.collapseDropdown(_r3); });
        i0.ɵɵelementStart(40, "div", 32);
        i0.ɵɵelementStart(41, "a", 22);
        i0.ɵɵelement(42, "img", 23);
        i0.ɵɵelement(43, "span", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "div", 32);
        i0.ɵɵelementStart(45, "a", 22);
        i0.ɵɵelement(46, "img", 33);
        i0.ɵɵelement(47, "span", 34);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(48, "div", 32);
        i0.ɵɵelementStart(49, "a", 22);
        i0.ɵɵelement(50, "img", 35);
        i0.ɵɵelement(51, "span", 36);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(52, SessionScheduledPopupComponent_div_52_Template, 2, 0, "div", 37);
        i0.ɵɵtemplate(53, SessionScheduledPopupComponent_div_53_Template, 2, 3, "div", 38);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.isCoach && ctx.selectedUser != null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isCoach);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(19, _c1, ctx.confirmAttributes.selectedDate.format("dddd, DD MMMM"), ctx.confirmAttributes.hour));
        i0.ɵɵadvance(4);
        i0.ɵɵattribute("href", "../../../../../../../../content/images/sprite.svg?v=3#" + ctx.sessionType, null, "xlink");
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("jhiTranslate", "sessionSchedule.paragraph." + ctx.sessionType);
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate1("emoji", "flag-", i0.ɵɵpipeBind1(20, 15, ctx.session == null ? null : ctx.session.langKey), "");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 17, ctx.session == null ? null : ctx.session.langKey));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(22, _c2, ctx.session == null ? null : ctx.session.duration));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isCoach && ctx.isCoronaUser);
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("href", ctx.googleReminder, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(11);
        i0.ɵɵpropertyInterpolate("href", ctx.googleReminder, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("href", ctx.outlookReminder, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("href", ctx.yahooReminder, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.isCoronaUser);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.threshold != null);
    } }, directives: [i8.JhiTranslateDirective, i9.NgIf, i10.FaIconComponent, i11.EmojiComponent, i2.NgbDropdown, i2.NgbDropdownToggle, i2.NgbDropdownMenu], pipes: [i12.FindFlagCodeFromKeyPipe, i13.FindLanguageFromKeyPipe], styles: [""] });
